import application from "./shared_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import { Modal } from "tailwindcss-stimulus-components";

// register the file-upload controller specifying src/controllers or src/public/controllers
const context = require.context("../src/controllers", true, /^(?!.*file_upload_controller\.js).*\.js/);
application.load(definitionsFromContext(context));
application.register("modal", Modal);
